import { ApiResponse } from "../dto/ApiResponse";
import { SellingStrategyId } from "../dto/BriefJAM";
import { resolveUrl } from "../utils/UrlResolver";
import { ApiClient } from "./ApiClient";


export class SellingStrategyApiClient extends ApiClient {
    public static key="SellingStrategyApiClient";

    public async GetSellingStrategies(): Promise<SellingStrategyId[]> {
        const token = localStorage.getItem("token") ?? "";
        const ret = await this.Get<ApiResponse<any>>(resolveUrl(`${this.baseUrl}`, `/sellingStrategy/`), token);
        return ret.data 
    }
}